import {combineReducers} from 'redux';
import files from './files';

const rootReducer = combineReducers({
    files:files
});

export default rootReducer;